import React from 'react';
import {
  ShareLayer
} from '../../components/ShareLinksMobile';
import SocialLinksContainer, { SocialLinksContainerProps }  from '../SocialLinksContainer';


interface ShareLayerContainerProps {
  show: boolean;
}

const ShareLayerContainerMobile = ({
  show,
  onCopiedToClipboard
 }: ShareLayerContainerProps & SocialLinksContainerProps) => {
  return (
    <ShareLayer show={show}>
      <SocialLinksContainer type={'navi'} onCopiedToClipboard={onCopiedToClipboard} />
    </ShareLayer>
  );
};

export default ShareLayerContainerMobile;
